import React, {useState, useEffect, useRef} from 'react'

import classes from './PopupMinigameStars.module.css'
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import {CountUp} from 'countup.js';
import clsx from 'clsx';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Minigame from '@/js/Minigames/Minigame';
import Star from '@/components/shared/Star/Star';
import ActivityTitle from '../PopupMinigameSequence/ActivityTitle/ActivityTitle';
import ActivityLogoName from '@/components/shared/ActivityLogoName/ActivityLogoName';
import SoundPlayer from 'react-sdk/SoundPlayer';


const PopupMinigameStars = () => {


  /** @type {Minigame} */
  let mg = PopupsManager.getData(POPUPS.MINIGAME_STARS)
  const [animInProgress, setAnimInProgress] = useState(true)
  const [currentStarNb, setCurrentStarNb] = useState(0)

  function setCurrentStarNbWithAudio(nb) {
    SoundPlayer.playSound("star_appear")
    setCurrentStarNb(nb)
  }
  const icon = mg?.icon
  const delayAnim = 500
  useEffect(() => {
    let stars = 0
    if (mg)
      stars = mg.getStars()
    
    if (stars > 0) {
      setAnimInProgress(true)
      setCurrentStarNb(0)
      // MEH
      if (stars == 3) {
        setTimeout(() => {
          setCurrentStarNbWithAudio(1)
        }, delayAnim);
        setTimeout(() => {
          setCurrentStarNbWithAudio(2)
        }, delayAnim * 2);
        setTimeout(() => {
          setCurrentStarNbWithAudio(3)
          setAnimInProgress(false)
        }, delayAnim * 3);
      } else if (stars == 2) {
        setTimeout(() => {
          setCurrentStarNbWithAudio(1)
        }, delayAnim);
        setTimeout(() => {
          setCurrentStarNbWithAudio(2)
          setAnimInProgress(false)
        }, delayAnim * 2);
      } else {
        setTimeout(() => {
          setCurrentStarNbWithAudio(1)
          setAnimInProgress(false)
        }, delayAnim);
      }
    } else {
      setAnimInProgress(false)
      setCurrentStarNb(0)
    }
  }, []);

  function handleClick() {
    PopupsManager.close(POPUPS.MINIGAME_STARS)
  }

  return (
    /*<Popup className={classes.PopupMinigameStars}>
      {mg &&
      <div className={classes.stars_ctnr}>
        <SvgStar className={clsx(currentStarNb < 1 && classes.inactive)} ></SvgStar>
        <SvgStar className={clsx(currentStarNb < 2 && classes.inactive)} ></SvgStar>
        <SvgStar className={clsx(currentStarNb < 3 && classes.inactive)} ></SvgStar>
      </div>}
      <div className={classes.btn}>
        <Button onClick={handleClick} disabled={animInProgress}>Continuer</Button>
      </div>
    </Popup>*/

    <Popup className={classes.PopupMinigameStars}>

      <ActivityLogoName mg={mg} />

      <div className={classes.stars}>
        {new Array(3)
        .fill("")
        .map((_, index) => {
          if(index < currentStarNb) return <div className={classes.star}><Star filled /></div>
          else return <div className={classes.star}><Star /></div>
        })}
      </div>

      <div className={classes.btn}>
        <Button onClick={handleClick} disabled={animInProgress}>Continuer</Button>
      </div>


    </Popup>
  );
};

export default PopupMinigameStars;
